import { startOfDay, endOfDay } from 'date-fns'

export function toStartOfDay (date: string | number | Date) {
  if (!date) {
    return undefined
  }

  return startOfDay(new Date(date))
}

export function toStartOfDayIsoString (date: string | number | Date) {
  const start = toStartOfDay(date)

  if (start) {
    return start.toISOString()
  }

  return undefined
}

export function toEndOfDay (date: string | number | Date) {
  if (!date) {
    return undefined
  }

  return endOfDay(new Date(date))
}

export function toEndOfDayIsoString (date: string | number | Date) {
  const end = toEndOfDay(date)

  if (end) {
    return end.toISOString()
  }

  return undefined
}

export function today () {
  return toDateString(new Date())
}

export function sixMonthsAgo () {
  const date = new Date()
  date.setMonth(date.getMonth() - 6)
  return toDateString(date)
}

export function toDateString (date: Date) {
  const dateString = date.toISOString()
  return dateString.split('T')[0]
}

let weekDays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']

export function formatDate (value: Date | string) {
  if (value) {
    value = new Date(value)
    return `${addLeadingZero(value.getDate())}.${addLeadingZero(value.getMonth() + 1)}.${value.getFullYear()}`
  }
  return ''
}

export function formatInputDate (value: Date | string) {
  return value ? new Date(value).toLocaleDateString('sv-SE') : ''
}

export function formatTime (value: Date | string) {
  if (value) {
    value = new Date(value)
    let h = value.getHours()
    let m = value.getMinutes()
    // add a zero in front of numbers<10
    h = addLeadingZero(h)
    m = addLeadingZero(m)
    return `${h}:${m}`
  }
  return ''
}

export function formatTripDateTime (value: Date | string) {
  if (value) {
    value = new Date(value)
    return `${weekDays[value.getDay()]}, ${formatDateTime(value)} Uhr`
  }
  return ''
}

export function formatDateTime (value: Date | string) {
  return `${formatDate(value)} ${formatTime(value)}`
}

export function formatDateTimeString (value: string) {
  return formatDateTime(new Date(value))
}

export function formatDateString (value: string) {
  return formatDate(new Date(value))
}

function addLeadingZero (i) {
  if (i < 10) {
    i = `0${i}`
  }
  return i
}
